import { createStore } from 'jotai';

/**
 * App-level Jotai store — shared by all global drawers and their callers.
 *
 * Why: `@daily-co/daily-react`'s `DailyProvider` creates a nested Jotai
 * `Provider` with its own isolated store. Components inside a Daily session
 * (e.g. `AppointmentStatusCard`) read/write from Daily's store, while global
 * components in `_app.tsx` (e.g. `SchedulingDrawer`, `ChatDrawer`) read/write
 * from the app-level store. Without an explicit store, atoms set inside the
 * session page are invisible to global drawers.
 *
 * This store is passed to `<Provider store={appStore}>` in `_app.tsx` and
 * used explicitly via `useAtomValue(atom, { store: appStore })` /
 * `useSetAtom(atom, { store: appStore })` in hooks that must communicate
 * across the store boundary.
 */
export const appStore = createStore();
